import update from 'immutability-helper';
import { SERVICE_INTEGRATION_MODE_MAIN, DEFAULT_AVL_INT_SORT } from '@utils/constants';
import * as types from './types';

const initialState = {
  mode: SERVICE_INTEGRATION_MODE_MAIN,
  sort: DEFAULT_AVL_INT_SORT,
  showEnablePartnerModal: false,
};

const switchMap = {};

switchMap[types.INIT] = state => update(state, {
  $set: initialState,
});

switchMap[types.SET_MODE] = (state, action) => update(state, {
  mode: { $set: action.mode },
});

switchMap[types.SET_SORT] = (state, action) => {
  const { sort } = action;
  return update(state, {
    sort: { $set: sort },
  });
};

switchMap[types.CHANGE_ENABLE_PARTNER_MODAL_VISIBILITY] = (state, action) => update(state, {
  showEnablePartnerModal: { $set: action.visible },
});

export default (state = initialState, action) => (switchMap[action.type]
  ? switchMap[action.type](state, action) : state);
